export default __webpack_public_path__ + "static/media/Series-8200-MPHT-Insertion-Remote.0039a67b.png";